import { Component, OnInit } from '@angular/core';
import { PlatformSidebarState } from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import { Store } from '@ngrx/store';
import { ConversationComponentName, ConversationListComponentName } from '../../store/collaboration.constants';
import { SetCurrentRightSideComponentAction } from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import { CreateChatConversationCommand } from '../../store/collaboration.command';
import { ContentScope } from '@shared/commands/command-base';
import { CollaborationState } from '../../store/collaboration.reducer';
import { CreateChatConversationAction } from '../../store/collaboration.action';
import {DialogService} from "@shared/services/dialog-service";
import { MatDialog } from "@angular/material/dialog";
import {ContactFormComponent} from "../../../../contacts/components/contact-form/contact-form.component";
import {takeUntil} from "rxjs/operators";
import {OnDestroy} from "@angular/core";
import {Subject} from "rxjs";
import {AddContactFormComponent} from "@shared/components/add-contact-form/add-contact-form.component";
import {AddContactDialogComponent} from "../add-contact-dialog/add-contact-dialog.component";
import {ShareItemsComponent} from "@shared/components/share-items/share-items.component";
import {ContactState} from "../../../../contacts/store/contact.reducer";
import {GetAllSharedContactsAction} from "../../../../contacts/store/contact.action";

@Component({
    standalone: false,
    selector: 'collaboration-new-conversation',
  templateUrl: './new-conversation.component.html',
  styleUrls: ['./new-conversation.component.scss']
})
export class NewConversationComponent implements OnInit, OnDestroy {
  selectedContacts: any[];
  addContactEnabled: boolean = false;
  private unsubscribe$ =  new Subject<void>();

  constructor(private platformSidebarStore: Store<PlatformSidebarState>,
              private collaborationStore: Store<CollaborationState>,
              protected dialogService: DialogService,
              protected dialog: MatDialog,
              private contactStore: Store<ContactState>) {
  }

  ngOnInit() {
    this.addContactEnabled = false;
  }

  onSelectionChanged(selectedItems: any[]) {
    this.selectedContacts = selectedItems;
   console.log(selectedItems);
  }

  navigateToConversation() {
    this.createChatConversation();
  }

  navigateToConversationList() {
    this.platformSidebarStore.dispatch(new SetCurrentRightSideComponentAction({component: ConversationListComponentName, data: {}, componentInfo: null}));
  }

  private createChatConversation () {
    if (!this.selectedContacts && ! this.selectedContacts.length) {
      return;
    }
    const rolesArray = [];
    this.selectedContacts.forEach(item => {
      rolesArray.push({'user': item.user, 'roleTypes': [1, 2, 3]});
    });
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      this.getTitle(),
      true,
      0,
      'Conversation',
      rolesArray
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }
  addConatacs() {
    //this.addContactEnabled = true;
    const key = 'AllContactList';
    const dialogRef = this.dialog.open(ShareItemsComponent, {
      minWidth: '800px',
      maxWidth: '800px',
      data: {
        showTaskManagerRole: false,
        queryKey: key,
        itemId: '',
        selectIndex: 1
      }
    });
    dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe$)).subscribe((result: string) => {
      console.log();
      this.contactStore.dispatch(new GetAllSharedContactsAction());
    });
  }
  private getTitle () {
    return this.selectedContacts.length === 1 ? this.selectedContacts[0].name : this.selectedContacts.reduce(function (a, b) {return (a.name || a) + ', ' + b.name; }) ; // todo: self user is not here;
  }

  onAddContactAction(action) {
    console.log('action:', action);
    if(action === 'addContactDone' || action === 'addContactCancel') {
      this.addContactEnabled = false;
    }
  }
  ngOnDestroy(){
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
